// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MBHUlV {
  display: flex;
  align-items: center;
  width: 100%;
  height: 82px;
  background: var(--background-alt);
  border: none;
  border-radius: var(--radius-s);
  padding: var(--spacing-2);
  cursor: pointer;
}

.vJt5I5 {
  width: 32px;
  height: 32px;
  object-fit: cover;
  margin-right: 16px;
  background: #f5f5f5;
  border-radius: 50%;
}

.JU34iZ {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: var(--spacing-0-5);
}

.Y9FaOE {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.LQ6kC8 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.DH46hO {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.DH46hO::before {
  content: '-';
  margin-right: var(--spacing-0-5);
}

.hZCm4_ {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--status-success);
}

.YURFhi {
  width: 16px;
  height: 16px;
  object-fit: cover;
  margin-left: var(--spacing-2);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ExtractTransaction/ExtractTransaction.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B","sourcesContent":[".transaction {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 82px;\n  background: var(--background-alt);\n  border: none;\n  border-radius: var(--radius-s);\n  padding: var(--spacing-2);\n  cursor: pointer;\n}\n\n.image {\n  width: 32px;\n  height: 32px;\n  object-fit: cover;\n  margin-right: 16px;\n  background: #f5f5f5;\n  border-radius: 50%;\n}\n\n.info {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.description {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.cashOutAmount {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.cashOutAmount::before {\n  content: '-';\n  margin-right: var(--spacing-0-5);\n}\n\n.cashInAmount {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--status-success);\n}\n\n.imageArrowChevronRight {\n  width: 16px;\n  height: 16px;\n  object-fit: cover;\n  margin-left: var(--spacing-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transaction": `MBHUlV`,
	"image": `vJt5I5`,
	"info": `JU34iZ`,
	"title": `Y9FaOE`,
	"description": `LQ6kC8`,
	"cashOutAmount": `DH46hO`,
	"cashInAmount": `hZCm4_`,
	"imageArrowChevronRight": `YURFhi`
};
module.exports = ___CSS_LOADER_EXPORT___;
